<template>
  <a-radio-group
    :value="selectedCycleId"
    button-style="solid"
    size="small"
    @change="event => onSelectCycle(event.target.value)"
  >
    <a-radio-button
      value="prev"
      :disabled="isPrevDisabled"
    >
      <LeftOutlined />
    </a-radio-button>
    <a-radio-button
      v-for="cycle in cycles"
      :key="cycle.id"
      :value="cycle.id"
    >
      {{ cycle.displayName + $t('okr.cycle.fullYear') }}
    </a-radio-button>
    <a-radio-button
      value="next"
      :disabled="isNextDisabled"
    >
      <RightOutlined />
    </a-radio-button>
  </a-radio-group>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'

import {
  SELECT_CYCLE,
  SELECT_CYCLE_YEAR
} from '@/store/mutation-types'

export default {
  components: {
    LeftOutlined,
    RightOutlined
  },
  setup () {
    const { query } = useRoute()
    const store = useStore()
    const defaultCycleId = query.cycle_id && +query.cycle_id

    if (store.state.yearCycles.length === 0) {
      store.dispatch('getCycles', defaultCycleId)
    }

    const cycles = computed(() => {
      // return store.state.selectedCycleId
      //   ? store.state.yearCycles[store.state.activeYearIndex]
      //   : []
      return store.state.yearCycles[store.state.activeYearIndex]
    })

    function onSelectCycle (id) {
      if (id === 'prev') {
        store.commit(SELECT_CYCLE_YEAR, false)
      } else if (id === 'next') {
        store.commit(SELECT_CYCLE_YEAR, true)
      } else {
        store.commit(SELECT_CYCLE, id)
      }
    }

    const isPrevDisabled = computed(() =>
      store.state.activeYearIndex === 0
    )
    const isNextDisabled = computed(() =>
      store.state.activeYearIndex === store.state.yearCycles.length - 1
    )

    return {
      selectedCycleId: computed(() => store.state.selectedCycleId),
      isPrevDisabled,
      isNextDisabled,
      cycles,
      onSelectCycle
    }
  }
}
</script>
